import posthog from "posthog-js";
import * as Sentry from "@sentry/nextjs";
Sentry.init({
  dsn: "https://e847294510b54d0bb6ecaf0853156b58@o1047677.ingest.sentry.io/6273263",
  tracesSampleRate: 0,
  integrations: [new posthog.SentryIntegration(posthog, "modfy", "6273263")],
  enabled: process.env.NODE_ENV !== "development"
});
